module.exports = __webpack_public_path__ + "img/svg_email.48a07836.svg";